import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function MenuHandler() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (loading) {
    return <div className="h-10 w-24 animate-pulse rounded bg-muted/20" />;
  }
  const items = menuItems.length > 0 ? menuItems : [{
    id: "home",
    label: "HOME",
    href: "/HomePage"
  }, {
    id: "treatments",
    label: "THE TREATMENTS",
    href: "/TreatmentsPage"
  }, {
    id: "contact",
    label: "BOOK NOW",
    href: "/GetInTouchPage"
  }];
  return <>
      {}
      <div className="hidden md:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList className="gap-6">
            {items.map(item => <NavigationMenuItem key={item.id}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="group relative font-serif text-[13px] font-bold tracking-widest text-foreground/90 transition-all hover:text-primary py-2 uppercase">
                    {item.label}
                    <span className="absolute bottom-0 left-1/2 h-[1px] w-0 -translate-x-1/2 bg-primary transition-all duration-300 ease-out content-[''] group-hover:w-full" />
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      {}
      <button onClick={() => setIsMobileOpen(!isMobileOpen)} className="text-foreground md:hidden focus:outline-none" aria-label="Toggle menu">
        {isMobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {}
      {isMobileOpen && <div className="absolute left-0 top-full w-full border-b border-border/40 bg-background/95 backdrop-blur-2xl md:hidden animate-in slide-in-from-top-5 fade-in duration-200">
          <nav className="container mx-auto flex flex-col gap-4 p-6">
            {items.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="font-serif text-sm font-bold tracking-widest text-foreground/80 hover:text-primary transition-colors uppercase" onClick={() => setIsMobileOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="22417" id="header" className="dark relative z-50">
      <header className={cn("fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 border-b", isScrolled ? "bg-background/80 backdrop-blur-md border-border/40 shadow-xl" : "bg-background border-transparent")}>
        <div className="container mx-auto flex h-16 items-center justify-between px-4 md:px-6">
          {}
          <Link to="/HomePage" className="flex items-center gap-2 focus:outline-none">
            <div className="relative flex h-10 w-10 items-center justify-center overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593773/img/bt_hexagon_logo.png" alt="Bathers Auto Detailing Logo" className="h-full w-full object-contain" />
            </div>
          </Link>

          {}
          <MenuProvider menu_id="46" className="flex items-center">
            <MenuHandler />
          </MenuProvider>
        </div>
      </header>
    </section>;
}